import usePageMeta from "utils/usePageMeta";
import PageHero from "reusables/layouts/PageHero";
import cleaningBg from "assets/images/office9.jpg";
import ServicesSection from "reusables/sections/ServicesSection";
import HowItWorks from "reusables/sections/HowItWorks";

import cleaningRoutes from "routes/cleaning";
import routesToServiceData from "utils/routesToServiceData";

import one from "assets/images/Main/numbers/1.png";
import two from "assets/images/Main/numbers/2.png";
import three from "assets/images/Main/numbers/3.png";
import four from "assets/images/Main/numbers/4.png";
import five from "assets/images/Main/numbers/5.png";
import six from "assets/images/Main/numbers/6.png";

const cleaningSteps = [
  {
    image: one,
    name: "Choose Your Cleaning Plan",
    label:
      "Select the frequency that best suits your needs: daily, weekly, fortnightly, or monthly.",
  },
  {
    image: two,
    name: "Request a Quote",
    label:
      "Provide details about your property, such as size and specific cleaning requirements, and we'll give you a transparent quote tailored to your needs.",
  },
  {
    image: three,
    name: "Schedule Your Cleaning",
    label:
      "Pick a convenient date and time for your cleaning sessions. We'll work around your schedule to ensure minimal disruption.",
  },
  {
    image: four,
    name: "Meet Your Professional Cleaner",
    label:
      "Our trained and experienced cleaners will arrive on time, equipped to handle all tasks on your personalised cleaning checklist.",
  },
  {
    image: five,
    name: "Enjoy a Spotless Space",
    label:
      "Relax and enjoy your fresh, clean environment. With regular cleaning, you'll maintain a consistently tidy and hygienic space without the hassle.",
  },
  {
    image: six,
    name: "Stay Flexible",
    label:
      "Need to make changes? We're here to accommodate adjustments in schedule or services as your needs evolve.",
  },
];

function CleaningPage() {
  usePageMeta({
    title: "Spechs Cleaning Services | Residential & Commercial Cleaning Ireland",
    description:
      "Professional cleaning services for homes, offices, schools, and commercial properties across Ireland. Residential, deep clean, end-of-tenancy, and more.",
    canonical: "https://www.spechs.ie/cleaning/",
  });

  return (
    <PageHero
      title="Spechs Cleaning Services"
      subtitle="Professional cleaning for homes, offices, and commercial properties across Ireland."
      bgImage={cleaningBg}
    >
      <ServicesSection
        title="Our Cleaning Services"
        description="We offer a wide range of professional cleaning services."
        data={routesToServiceData(cleaningRoutes)}
        color="success"
      />
      <HowItWorks
        title="How It Works"
        description="Our cleaning services are designed to make your life easier and your spaces spotless. Here's how it works:"
        steps={cleaningSteps}
      />
    </PageHero>
  );
}

export default CleaningPage;
